module.exports = __webpack_public_path__ + "img/send-icon.890aa582.svg";